import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-business-maintenance',
  templateUrl: './business-maintenance.component.html',
  styleUrls: ['./business-maintenance.component.scss']
})
export class BusinessMaintenanceComponent implements OnInit, IConditionalSection {
  @Input() business: Business;

  _interiorTags: String[] = [];
  _exteriorTags: String[] = [];
  _airframeTags: String[] = [];
  _airframeManufacturerTags: String[] = [];
  _powerplantTags: String[] = [];
  _powerplantManufacturerTags: String[] = [];
  _propellerTags: String[] = [];
  _propellerManufacturerTags: String[] = [];
  _avionicsTags: String[] = [];
  _avionicsManufacturerTags: String[] = [];

  editModeSet = false;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              private _editMaintenanceCheckboxDialog: MatDialog,
              public snackBar: MatSnackBar,
              private _businessManagerService: BusinessManagerService) {
  }

  async ngOnInit() {
    this.loadAllTags();
    this._toggleService.toggleEmitter.subscribe(isOn => this.editModeSet = isOn);
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  get hasContent(): boolean {
    return (this._interiorTags.length > 0 || this._exteriorTags.length > 0 ||
      this._airframeTags.length > 0 || this._airframeManufacturerTags.length > 0 ||
      this._powerplantTags.length > 0 || this._powerplantManufacturerTags.length > 0 ||
      this._propellerTags.length > 0 || this._propellerManufacturerTags.length > 0 ||
      this._avionicsTags.length > 0 || this._avionicsManufacturerTags.length > 0);
  }

  openEditMaintenanceDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editMaintenanceCheckboxDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        this.loadAllTags();
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  get interiorTags(): String[] {
    return this._interiorTags;
  }

  get exteriorTags(): String[] {
    return this._exteriorTags;
  }

  get airframeTags(): String[] {
    return this._airframeTags;
  }

  get airframeManufacturerTags(): String[] {
    return this._airframeManufacturerTags;
  }

  get powerplantTags(): String[] {
    return this._powerplantTags;
  }

  get powerplantManufacturerTags(): String[] {
    return this._powerplantManufacturerTags;
  }

  get propellerTags(): String[] {
    return this._propellerTags;
  }

  get propellerManufacturerTags(): String[] {
    return this._propellerManufacturerTags;
  }

  get avionicsTags(): String[] {
    return this._avionicsTags;
  }

  get avionicsManufacturerTags(): String[] {
    return this._avionicsManufacturerTags;
  }

  loadAllTags() {
    // Load Interior
    this._interiorTags = loadTags(this.business.tags, 'Maintenance::Interior::', '', '');

    // Load Exterior
    this._exteriorTags = loadTags(this.business.tags, 'Maintenance::Exterior::', '', '');

    // Load Airframe
    this._airframeTags = loadTags(this.business.tags, 'Maintenance::Airframe::', '', 'Maintenance::Airframe::Manufacturers::');

    // Load Airframe Manufacturer
    this._airframeManufacturerTags = loadTags(this.business.tags, 'Maintenance::Airframe::Manufacturers::', '', '');

    // Load Powerplant
    this._powerplantTags = loadTags(this.business.tags, 'Maintenance::Powerplant::', '', 'Maintenance::Powerplant::Manufacturers::');

    // Load Powerplant Manufacturer, but exclude the FAA repair tag.
    this._powerplantManufacturerTags = loadTags(this.business.tags, 'Maintenance::Powerplant::Manufacturers::', '', '')
    .filter(tagName => !tagName.includes('FAA Repair'));

    // Load Propeller
    this._propellerTags = loadTags(this.business.tags, 'Maintenance::Propeller::',
      'Maintenance::Rotor::', 'Maintenance::Propeller::Manufacturers::');

    // Load Propeller Manufacturer
    this._propellerManufacturerTags = loadTags(this.business.tags, 'Maintenance::Propeller::Manufacturers::', '', '');

    // Load Avionics
    this._avionicsTags = loadTags(this.business.tags, 'Maintenance::Avionics::', '', 'Maintenance::Avionics::Manufacturers::');

    // Load Avionics Manufacturer
    this._avionicsManufacturerTags = loadTags(this.business.tags, 'Maintenance::Avionics::Manufacturers::', '', '');
  }


}
